<template>
  <div class="login-container">
    <div class="login-form-container">
      <img src="../assets/image/slogan.png" />
      <h3 class="title">果园工作台</h3>
      <a-form-model
        id="components-form-demo-normal-login"
        ref="loginForm"
        class="login-form"
        :model="form"
      >
        <a-form-model-item>
          <a-input
            v-model="form.user_name"
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: 'Please input your email!' },
                ],
              },
            ]"
            placeholder="email"
          >
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input
            v-model="form.password"
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: 'Please input your Password!' },
                ],
              },
            ]"
            type="password"
            placeholder="Password"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-checkbox
            v-model="form.remember_me"
            v-decorator="[
              'remember',
              { valuePropName: 'checked', initialValue: true },
            ]"
          >
            <span>Remember me</span>
          </a-checkbox>
          <!-- <a class="login-form-forgot" href>Forgot password</a> -->
          <a-button
            @click="handleSubmit"
            type="primary"
            :loading="loading"
            class="login-form-button"
            >Login</a-button
          >
          <!-- <a href>register now!</a> -->
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { Checkbox } from "ant-design-vue";
import { mapMutations, mapState } from "vuex";
// import md5 from "js-md5";
export default {
  components: {
    "a-checkbox": Checkbox,
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("user_info")) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  },
  data() {
    return {
      loading: false,
      form: {
        user_name: "wjzhu",
        password: "123456",
        remember_me: true,
      },
    };
  },
  computed: {
    ...mapState(["user_info"]),
  },
  created() {
    if (this.user_info) {
      this.$router.push("/");
    }
  },
  methods: {
    ...mapMutations(["setState"]),
    handleSubmit(e) {
      e.preventDefault();
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.login();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    login() {
      let data = {
        user_name: this.form.user_name,
        password: this.form.password,
      };
      this.loading = true;
      this.$axios({
        url: this.$api.login,
        data,
      })
        .then((res) => {
          this.setState({
            user_info: res.result.user,
          });
          this.$message.success("登陆成功");
          this.loading = false;
          this.$router.push("/");
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$color: red;

.login-container {
  width: 100%;
  min-height: 100%;
  min-width: 1200px;
  // background-image: url('/banner2.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  align-items: center;

  .login-form-container {
    max-width: 300px;
    margin: 0 auto;
    box-shadow: 2px 2px 20px #eeeeee;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-60%) translateY(-50%);
    .title {
      text-align: center;
      padding: 30px 0 0;
      font-size: 30px;
    }
  }
  .login-slogan {
    display: flex;
    align-items:center;
  }
  .login-form {
    // background: rgba(0, 0, 0, 0.1);
    min-width: 300px;
    padding: 40px 30px 5px 30px;
    border-radius: 4px;
  }
  .login-form-forgot {
    float: right;
  }
  .login-form-button {
    width: 100%;
  }
}
</style>
